export default __webpack_public_path__ + "static/media/Rocket.c0e1d7d3.svg";